import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';

import { DistributionModel } from '../../../models/distribution.model';
import { DistributionPlainTextService } from './plain-text.service';
import { FullProfileAnimationModel } from '../../../../../Core/Dialogs/models/full-profile-animation.model';

enum ActionTypesEnum {
    save,
    cancel
};
@Component({
    selector: 'agpr-plain-text-editor-dialog',
    templateUrl: './plain-text-editor-dialog.component.html',
    styleUrls: ['./plain-text-editor-dialog.component.scss'],
    standalone: false
})

export class PlainTextEditorDialogComponent extends AbstractDialogComponent {

    @Input() set setDistribution(distribution: DistributionModel) {
        this.distribution = distribution;
        this.bodyPlainText = distribution.bodyPlainText || this.plainTextService.generateBodyPlainText(this.distribution.blocks);
        this.footerPlainText = distribution.footerPlainText?.replace(/^=+\n+/g, '') || this.plainTextService.generateFooterPlainText(this.distribution.blocks);
    }
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    hideSlideOverlay: boolean = false;

    readonly actionTypesEnum = ActionTypesEnum;
    actionType: ActionTypesEnum;

    distribution: DistributionModel;
    bodyPlainText: string;
    footerPlainText: string;

    public readonly buttonTypes = ButtonTypesEnum;
    public readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        public localizationService: LocalizationService,
        public plainTextService: DistributionPlainTextService
    ) {
        super(coreDialogService, 'PlainTextEditor');
    }

    regenerate(): void {
        this.bodyPlainText = this.plainTextService.generateBodyPlainText(this.distribution.blocks);
        this.footerPlainText = this.plainTextService.generateFooterPlainText(this.distribution.blocks);
    }

    close(action: ActionTypesEnum): void {
        this.actionType = action;
        this.hideSlideOverlay = true;
    }

    handleVisibleChange(isVisible: boolean) {
        if(!isVisible) {
            switch(this.actionType){
                case ActionTypesEnum.save:
                    const footerPlainText = this.plainTextService.footerSeparator.repeat(40) + '\n\n' + this.footerPlainText;
                    this.closeDialog({bodyPlainText: this.bodyPlainText, footerPlainText: footerPlainText});
                    break;
                case ActionTypesEnum.cancel:
                default:
                    this.closeDialog(null);
            }
        }
    }
}
